import { render, staticRenderFns } from "./IframeOrdini.vue?vue&type=template&id=3440daea"
import script from "./IframeOrdini.vue?vue&type=script&lang=js"
export * from "./IframeOrdini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports